import { RelationshipUtils } from '../relationship/relationship-utils';

function entityName(entityId, rootGetters) {
  if (entityId === 'membership') {
    return 'membership';
  }

  const entities =
    rootGetters['builder/entityCurrent/list'];
  return entities.find((e) => e.id === entityId)?.name
    ?.singular;
}

export function fieldType(field, entity, rootGetters) {
  if (RelationshipUtils.isRelationship(field)) {
    if (field.entityA === entity.id) {
      const _entityName = entityName(
        field.entityB,
        rootGetters,
      );

      if (field.type === 'many-to-many-implicit') {
        return `${_entityName}[]`;
      }

      if (field.type === 'many-to-many-explicit') {
        return `${_entityName}[]`;
      }

      if (field.type === 'many-to-one') {
        return `${_entityName}`;
      }

      if (field.type === 'one-to-one') {
        return `${_entityName}`;
      }
    } else {
      const _entityName = entityName(
        field.entityA,
        rootGetters,
      );

      if (field.type === 'many-to-many-implicit') {
        return `${_entityName}[]`;
      }

      if (field.type === 'many-to-many-explicit') {
        return `${_entityName}[]`;
      }

      if (field.type === 'many-to-one') {
        return `${_entityName}[]`;
      }

      if (field.type === 'one-to-one') {
        return `${_entityName}`;
      }
    }
  }

  if (!field.type) {
    return '';
  }

  return rootGetters['builder/fieldType/label'](field.type);
}
